<div class="modal-alert">

	<div class="modal-header">
        <div class="d-flex flex-row justify-content-center align-items-center">
            <span class="material-icons custom-modal-error-icon me-2">report_problem</span>
            <span class="fs-5 fw-bold">Error</span>
        </div>
	</div>

	<div class="modal-body">
		<div class="container">
			<div class="row">
                <div [innerHTML]="message"></div>
            </div>
		</div>
	</div>

	<div class="modal-footer">

        <button type="button" class="btn custom-modal-error-button" (click)="okButtonController()">
            <div class="d-flex flex-row justify-content-center align-items-center">
                <span class="material-icons">done</span>
			    <span>Aceptar</span>
            </div>
        </button>
		
	</div>
	
</div>
